export const SEROPHIN_SSM_PREFIX = "/serophin";

export const SEROPHIN_PARAMS = {
  claudeOauthToken: `${SEROPHIN_SSM_PREFIX}/claude-oauth-token`,
  unsplashAccessKey: `${SEROPHIN_SSM_PREFIX}/unsplash-access-key`,
  alertsTopicArn: `${SEROPHIN_SSM_PREFIX}/alerts-topic-arn`,
  anthropicApiKey: `${SEROPHIN_SSM_PREFIX}/anthropic-api-key`,
  cloudflareLbReadToken: `${SEROPHIN_SSM_PREFIX}/cloudflare-lb-read-token`,
} as const;

export const SEROPHIN_COST_TAGS = { app: "app", env: "env" } as const;
